/* eslint-disable */
import type { RequestContext } from "./RequestContextProto.pb";
import type { ResponseContext } from "./ResponseContextProto.pb";

/** Sent by the apps once the Persona dIDV inquiry, launched by PersonaDidvBlocker, has completed. */
export interface ResolvePersonaDidvBlockerRequest {
  request_context?: RequestContext;
  /** Indicates the state of completion of the inquiry */
  inquiry_response?: ResolvePersonaDidvBlockerRequestInquiryResponse;
  /** The created inquiry identifier */
  inquiry_id?: string;
  /** Should be failed or completed, indicates whether all parts of the inquiry were completed */
  status?: string;
  /** If inquiry_response is Cancelled, this identifier can later be used to resume the inquiry */
  session_token?: string;
  /** If inquiry_response is Error, the message contains why */
  debug_message?: string;
}

export enum ResolvePersonaDidvBlockerRequestInquiryResponse {
  /** ERROR - Something went wrong with the inquiry flow (e.g. template was misconfigured, network errors) */
  ERROR = "ERROR",
  /** CANCEL - The inquiry was abandoned by the user */
  CANCEL = "CANCEL",
  /** COMPLETE - The inquiry flow completed */
  COMPLETE = "COMPLETE",
}

/** Sent by the server in response to a ResolvePersonaDidvBlockerRequest. */
export interface ResolvePersonaDidvBlockerResponse {
  response_context?: ResponseContext;
}
